import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { IconButton } from "@material-ui/core";
import { FormGroup, Input, Collapse, Row, Col } from 'reactstrap';
import { ContactsOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
}));

function getSteps() {
    return [
        'DIVISION OF PROPERTY',
        'DIVISION OF DEBTS',
        'EQUALIZATION',
        'TRANSFER OF RETIREMENTS',
        'PARENTING PLAN',
        'SPOUSAL SUPPORT',
    ];
}

const MaritalSettlementAgreement = (props) => {



    const classes = useStyles();
    const [equalizationFirst, setEqualizationFirst] = useState(false);
    const [equalizationFourth, setEqualizationFourth] = useState(false);
    const [equalizationFifth, setEqualizationFifth] = useState(false);

    const [transferFirst, setTransferFirst] = useState(false);
    const [transferThird, setTransferThird] = useState(false);
    const [transferThirdA, setTransferThirdA] = useState(false);


    const [childInfo, setChildInfo] = useState([{ name: "", legal: "", sole: "" }]);
    const [inputField, setInputField] = useState([{ petitionerText: "" }]);
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();



    const handleChangeInput = (index, event) => {
        const values = [...inputField];
        values[index][event.target.id] = event.target.value;
        setInputField(values);
    }

    const handleAddFields = () => {
        setInputField([...inputField, { text: "" }])
    }


    const handleRemoveFields = (index) => {
        const values = [...inputField];
        if (index = 1)
            values.splice(index, 1);
        setInputField(values);
    }




    const handleChildInfo = (index, event) => {
        const values = [...childInfo];
        values[index][event.target.id] = event.target.value;
        setChildInfo(values);
    }

    const handleAddChildInfo = () => {
        setChildInfo([...childInfo, { name: "", legal: "", sole: "" }])
    }


    const handleRemoveChildInfo = (index) => {
        const values = [...childInfo];
        if (index = 1)
            values.splice(index, 1);
        setChildInfo(values);
    }





    const ColoredLine = ({ color }) => (
        <hr
            style={{
                borderTop: "0.9 px solid",
                color: "black",
            }}
        />
    );




    function getStepContent(step) {
        switch (step) {
            case 0:
                return (<div style={{ Color: "blue" }}>
                    <FormGroup>
                        <h3 style={{ fontStyle: "italic", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>DIVISION OF PROPERTY</h3>

                        <h5 style={{ marginTop: "20px" }}>First, let’s select some general options to include in your agreement.</h5>

                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>1. Please select which general provisions to apply for Petitioner:</h6>
                        <Input type="select">
                            <option>All checking, savings, money market, and all other financial accounts in Petitioner’s name.</option>
                            <option>Any and all retirement accounts in Petitioner’s name.</option>
                            <option>Any employment benefits, including term life insurance policy, health insurance, paid time off, and other benefits.</option>
                            <option>All clothing, jewelry, and personal effects in Petitioner’s possession.</option>
                            <option>Any credit card points, reward credits, and airline miles in Petitioner’s name.</option>
                            <option>Minimal cash in Petitioner’s possession.</option>
                        </Input>


                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>2. Please select which general provisions to apply for Respondent:</h6>
                        <Input type="select">
                            <option> All checking, savings, money market, and all other financial accounts in Respondent’s name.</option>
                            <option>Any and all retirement accounts in Respondent’s name.</option>
                            <option>Any employment benefits, including term life insurance policy, health insurance, paid time off, and other benefits.</option>
                            <option>All clothing, jewelry, and personal effects in Respondent’s possession.</option>
                            <option>Any credit card points, reward credits, and airline miles in Respondent’s name.</option>
                            <option>Minimal cash in Respondent’s possession.</option>
                        </Input>

                        <h5 style={{ marginTop: "20px" }}>Now, let’s put in specific assets.</h5>

                        <h6 style={{ marginTop: "10px" }}>Use your disclosure documents as a checklist so you remember all assets. Also, include the last four
           numbers of your and VIN for vehicles.</h6>

                        <h6> <h5>Hint:</h5> You can include an instruction like, “2017 Honda Accord Vin #XXX2134. Petitioner shall transfer title to his
           name no later than 45 days from signing the Agreement, and the Respondent shall cooperate to remove her name off title.”
           <br></br><br></br>
          “The 2014 Chevy Tahoe, VIN #XXX1234, in Respondent’s name, with an approximate value of $18,500.00, and a loan for approximately
           $12,300.00 in Respondent’s name.  Respondents shall be responsible for the loan.
           <br></br><br></br>

          See the sample MSA for suggested language.
          </h6>

                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>3. Write what other assets Petitioner will receive and any instructions for those assets:</h6>
                        {inputField.map((inputField, index) => (
                            <div key={index}>
                                <Input type="textarea" onChange={(e) => {handleChangeInput(index, e) }} />

                                <Row>
                    <Col>
                  <IconButton
                    onClick={() => handleAddFields()}
                    style={{
                      float:"right",
                      color: "black",
                      marginTop: "15px",
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => handleRemoveFields(index)}
                    style={{float:"right", color: "black", marginTop: "15px" }}
                  >
                    <RemoveIcon />
                  </IconButton>
                  </Col>
                  </Row>
                                <ColoredLine />
                            </div>
                        ))}

                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>4. Write what other assets Respondent will receive and any instructions for those assets:</h6>
                        {inputField.map((inputField, index) => (
                            <div key={index}>
                                <Input type="textarea" onChange={(e) => {handleChangeInput(index, e) }} />

                                <Row>
                    <Col>
                  <IconButton
                    onClick={() => handleAddFields()}
                    style={{
                      float:"right",
                      color: "black",
                      marginTop: "15px",
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => handleRemoveFields(index)}
                    style={{float:"right", color: "black", marginTop: "15px" }}
                  >
                    <RemoveIcon />
                  </IconButton>
                  </Col>
                  </Row>
                                <ColoredLine />
                            </div>
                        ))}
                    </FormGroup>
                </div>);


            case 1:
                return (<div>
                    <FormGroup >
                        <h3 style={{ fontStyle: "italic", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>DIVISION OF DEBTS</h3>

                        <h5 style={{ marginTop: "20px" }}>First, let’s select some general options that you can include in your agreement. </h5>

                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>1. Please select which general provisions to apply for Petitioner:</h6>
                        <Input type="select">
                            <option>Petitioner shall be responsible for any and all obligations (debts) in Petitioner’s name.</option>
                            <option>Petitioner shall be responsible for any and all credit card debts in Petitioner’s name.</option>
                            <option>Petitioner shall be responsible for any and all school loans in Petitioner’s name.</option>
                        </Input>


                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>2. Please select which general provisions to apply for Respondent:</h6>
                        <Input type="select">
                            <option>Respondent shall be responsible for any and all obligations (debts) in Respondent’s name.</option>
                            <option>Respondent shall be responsible for any and all credit card debts in Respondent’s name.</option>
                            <option>Respondent shall be responsible for any and all school loans in Respondent’s name.</option>
                        </Input>


                        {/* <h6> <h5>Hint: </h5>
          </h6> */}

                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>3. Next, please write in what other debts Petitioner will be responsible to pay:</h6>
                        {inputField.map((inputField, index) => (
                            <div key={index}>
                                <Input type="textarea" onChange={(e) => {handleChangeInput(index, e) }} />

                                <Row>
                    <Col>
                  <IconButton
                    onClick={() => handleAddFields()}
                    style={{
                      float:"right",
                      color: "black",
                      marginTop: "15px",
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => handleRemoveFields(index)}
                    style={{float:"right", color: "black", marginTop: "15px" }}
                  >
                    <RemoveIcon />
                  </IconButton>
                  </Col>
                  </Row>
                                <ColoredLine />
                            </div>
                        ))}

                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>4. Next, please write in what other debts Respondent will be responsible to pay:</h6>
                        {inputField.map((inputField, index) => (
                            <div key={index}>
                                <Input type="textarea" onChange={(e) => {handleChangeInput(index, e) }} />

                                <Row>
                    <Col>
                  <IconButton
                    onClick={() => handleAddFields()}
                    style={{
                      float:"right",
                      color: "black",
                      marginTop: "15px",
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => handleRemoveFields(index)}
                    style={{float:"right", color: "black", marginTop: "15px" }}
                  >
                    <RemoveIcon />
                  </IconButton>
                  </Col>
                  </Row>
                                <ColoredLine />
                            </div>
                        ))}

                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>5. Select additional language you want to include in the Debts section:</h6>
                        <div >
                            <Input type="select">
                                <option>The parties shall cooperate in canceling all joint credit cards and store accounts. </option>
                                <option>Neither party shall make any further charges on any credit card or store account for which the other party is or may be liable.</option>
                                <option >None</option>
                            </Input>
                        </div>
                    </FormGroup>
                </div>);


            case 2:
                return (<div>
                    <FormGroup>
                        <h3 style={{ fontStyle: "italic", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>EQUALIZATION</h3>

                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>1. Will either of you owe the other an equalization payment?</h6>
                        <Input type="select" onChange={(e) => setEqualizationFirst(JSON.parse(e.target.value))}>
                            <option disabled selected value>
                                {" "}
                  -- select an option --{" "}
                            </option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </Input>
                    </FormGroup>


                    <Collapse isOpen={equalizationFirst === 1 ? true : false} >
                        <FormGroup>
                            <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>2. Select who owes the payment to the other:</h6>
                            <Input type="select">
                                <option disabled selected value>
                                    {" "}
                                    -- select an option --{" "}
                                </option>
                                <option>Petitioner owes Respondent</option>
                                <option>Respondent owes Petitioner</option>
                            </Input>
                        </FormGroup>
                    </Collapse>


                    <Collapse isOpen={equalizationFirst === 0 ? true : false}>
                        <FormGroup>
                            <h6> </h6>
                        </FormGroup>
                    </Collapse>


                    <FormGroup>
                        <Row>
                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>3. How much does the spouse owe? <span style={{ marginLeft: "20px" }}>  $ </span></h6>
                        <Input type="number" style={{ marginLeft: "320px", width: "auto", marginTop: "-37px" }} />
                        </Row>

                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>4. Is the payment due all at once?</h6>
                        <Input type="select" onChange={(e) => setEqualizationFourth(JSON.parse(e.target.value))}>
                            <option disabled selected value>
                                {" "}
                                    -- select an option --{" "}
                            </option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </Input>
                    </FormGroup>


                    <Collapse isOpen={equalizationFourth === 1 ? true : false} >
                        <FormGroup>
                            <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>When is the payment due?</h6>
                            <Input type="date" style={{ marginLeft: "320px", width: "550px", marginTop: "-37px" }} />
                        </FormGroup>
                    </Collapse>


                    <Collapse isOpen={equalizationFourth === 0 ? true : false}>
                        <FormGroup>
                            <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>What is the payment plan? (allow for 200 characters)</h6>
                            <Input type="textarea" style={{}} />
                        </FormGroup>
                    </Collapse>


                    <FormGroup>
                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>5. Will any interest accrue if the payment is not  made on time?</h6>
                        <Input type="select" onChange={(e) => setEqualizationFifth(JSON.parse(e.target.value))}>
                            <option disabled selected value>
                                {" "}
                                    -- select an option --{" "}
                            </option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </Input>
                    </FormGroup>


                    <Collapse isOpen={equalizationFifth === 1 ? true : false} >
                        <FormGroup>
                            <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>How much interest will accrue per annum (i.e. 4%) % per annum?</h6>
                            <Input type="number" style={{ marginLeft: "540px"}} />
                        </FormGroup>
                    </Collapse>

                    <Collapse isOpen={equalizationFifth === 0 ? true : false}>
                        <FormGroup>

                        </FormGroup>
                    </Collapse>


                </div>);

            case 3:
                return (<div>

                    <FormGroup>
                        <h3 style={{ fontStyle: "italic", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>TRANSFER OF RETIREMENTS</h3>

                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>1. Will either of you need to transfer retirement from one of you to the other?</h6>
                        <Input type="select" onChange={(e) => setTransferFirst(JSON.parse(e.target.value))}>
                            <option disabled selected value>
                                {" "}
                                    -- select an option --{" "}
                            </option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </Input>
                    </FormGroup>


                    <Collapse isOpen={transferFirst === 0 ? true : false}>
                        <FormGroup>
                        </FormGroup>
                    </Collapse>

                    <Collapse isOpen={transferFirst === 1 ? true : false} >
                        <FormGroup>
                            <Row>
                            <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>2. How many transfers do you have? </h6>
                            <Input type="number" style={{ marginLeft: "330px"}} />

                            <h5 style={{ marginTop: "15px" }}>Let’s do one at a time.</h5>
                            </Row>
                        </FormGroup>


                        <FormGroup>
                            <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>3. Is the transfer retirement dollars or years of service/pension?</h6>
                            <Input type="select" onChange={(e) => setTransferThird(JSON.parse(e.target.value))}>
                                <option disabled selected value>
                                    {" "}
                                    -- select an option --{" "}
                                </option>
                                <option value="1">Retirement dollars</option>
                                <option value="0">Years of service/Pension</option>
                            </Input>
                        </FormGroup>


                        <Collapse isOpen={transferThird === 1 ? true : false} >
                            <FormGroup>

                                <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>3.a. Will a QDRO be needed?</h6>
                                <Input type="select" onChange={(e) => setTransferThirdA(JSON.parse(e.target.value))}>
                                    <option disabled selected value>
                                        {" "}
                                    -- select an option --{" "}
                                    </option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </Input>
                            </FormGroup>


                            <Collapse isOpen={transferThirdA === 1 ? true : false} >
                                <FormGroup>

                                </FormGroup>
                            </Collapse>


                            <Collapse isOpen={transferThirdA === 0 ? true : false}>
                                <FormGroup>

                                </FormGroup>
                            </Collapse>

                        </Collapse>

                        <Collapse isOpen={transferThird === 0 ? true : false}>
                            <FormGroup>

                            </FormGroup>
                        </Collapse>

                    </Collapse>
                </div>);

            case 4:
                return (<div>
                    <FormGroup>
                        <h3 style={{ fontStyle: "italic", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>PARENTING PLAN</h3>


                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>Do you have minor children?</h6>
                        <Input type="select" onChange={(e) => setEqualizationFifth(JSON.parse(e.target.value))}>
                            <option disabled selected value>
                                {" "}
                                    -- select an option --{" "}
                            </option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </Input>
                    </FormGroup>


                    <Collapse isOpen={equalizationFifth === 0 ? true : false}>
                        <FormGroup>

                        </FormGroup>
                    </Collapse>





                    <Collapse isOpen={equalizationFifth === 1 ? true : false} >
                        <FormGroup>
                            <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>1. Please complete the following:</h6>

                            {childInfo.map((childInformation, index) => (
                                <div key={index}>
                                    <Row>
                                        <Col lg="4">
                                            <h6 style={{ marginTop: "49px", fontWeight: "bold" }}>Child’s Name</h6>
                                            <Input type="text" onChange={(e) => {handleChildInfo(index, e) }} />
                                        </Col>

                                        <Col lg="4">
                                            <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>Legal Custody</h6>
                                            <h6 style={{ marginTop: "10px" }}>(Parent name or Joint)</h6>
                                            <Input type="text" onChange={(e) => {handleChildInfo(index, e) }} />
                                        </Col>

                                        <Col lg="4">
                                            <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>Sole Custody</h6>
                                            <h6 style={{ marginTop: "10px" }}>(Parent name or Joint)</h6>
                                            <Input type="text" onChange={(e) => {handleChildInfo(index, e) }} />
                                        </Col>
                                    </Row>
                                    <IconButton onClick={() => handleAddChildInfo()} style={{ marginLeft: "745px", color: "black", marginTop: "15px" }}>
                                        <AddIcon />
                                    </IconButton>
                                    <IconButton onClick={() => handleRemoveChildInfo(index)} style={{ color: "black", marginTop: "15px" }} >
                                        <RemoveIcon />
                                    </IconButton>
                                    <ColoredLine />
                                </div>
                            ))}



                            <FormGroup>
                                <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>2. Let’s work on the timeshare schedules. I’ll ask you for
                                 the Regular, Holiday and Summer schedules. </h6>
                                <h6 style={{ marginTop: "10px" }}>If you do not have one, you can select “None.” You can also
                                 edit the MSA at the end if you have unique preferences.</h6>

                                <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>A) Regular Schedule:</h6>


                                <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>Which schedule do you have?</h6>
                                <Input type="select" onChange={(e) => setEqualizationFifth(JSON.parse(e.target.value))}>
                                    <option disabled selected value>
                                        {" "}
                                    -- select an option --{" "}
                                    </option>
                                    <option value="0">Week On/Week Off</option>
                                    <option value="1"> 2-2-5-5 Schedule</option>
                                    <option value="2">2-2-3 Schedule</option>
                                    <option value="3">Other</option>
                                </Input>

                                <Collapse isOpen={equalizationFifth === 0 ? true : false} >
                                    <FormGroup>
                                        
                                    </FormGroup>
                                </Collapse>

                                <Collapse isOpen={equalizationFifth === 1 ? true : false}>
                                    <FormGroup>

                                    </FormGroup>
                                </Collapse>

                                <Collapse isOpen={equalizationFifth === 2 ? true : false}>
                                    <FormGroup>

                                    </FormGroup>
                                </Collapse>

                                <Collapse isOpen={equalizationFifth === 3 ? true : false}>
                                    <FormGroup>

                                    </FormGroup>
                                </Collapse>



                                <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>B) Holiday Schedule</h6>

                                <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>Please select from the following options:</h6>
                                <Input type="select" onChange={(e) => setEqualizationFifth(JSON.parse(e.target.value))}>
                                    <option disabled selected value>
                                        {" "}
                                    -- select an option --{" "}
                                    </option>
                                    <option value="0">We will not have a Holiday Schedule.</option>
                                    <option value="1">We will not specify the schedule, but agree geshare holidays so that each of 
                                            us receives equal custodial time either by sharing all the holidays, alternating or 
                                            some other agreed to method.
                                            </option>
                                    <option value="2">We have a Holiday Schedule that we will include as an attachment to the MSA.</option>
                                    <option value="3">Other</option>
                                </Input>

                                <Collapse isOpen={equalizationFifth === 0 ? true : false} >
                                    <FormGroup>
                                        
                                    </FormGroup>
                                </Collapse>

                                <Collapse isOpen={equalizationFifth === 1 ? true : false}>
                                    <FormGroup>

                                    </FormGroup>
                                </Collapse>

                                <Collapse isOpen={equalizationFifth === 2 ? true : false}>
                                    <FormGroup>

                                    </FormGroup>
                                </Collapse>

                                <Collapse isOpen={equalizationFifth === 3 ? true : false}>
                                    <FormGroup>

                                    </FormGroup>
                                </Collapse>



                                <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>C) Summer Schedule/Summer Vacation</h6>

                                <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>Please select from the following options:</h6>
                                <Input type="select" onChange={(e) => setEqualizationFifth(JSON.parse(e.target.value))}>
                                    <option disabled selected value>
                                        {" "}
                                    -- select an option --{" "}
                                    </option>
                                    <option value="0">We will not have a Summer Schedule. (It’s not different from the Regular Schedule
                                     and we are not including any vacation time).</option>
                                    <option value="1">We will each receive a set number of vacation days during the holidays.</option>
                                    <option value="2">Other</option>
                                </Input>

                                <Collapse isOpen={equalizationFifth === 0 ? true : false} >
                                    <FormGroup>
                                        
                                    </FormGroup>
                                </Collapse>

                                <Collapse isOpen={equalizationFifth === 1 ? true : false}>
                                    <FormGroup>

                                    </FormGroup>
                                </Collapse>

                                <Collapse isOpen={equalizationFifth === 2 ? true : false}>
                                    <FormGroup>

                                    </FormGroup>
                                </Collapse>

                            </FormGroup>


                        </FormGroup>
                    </Collapse>




                </div>);

            case 5:
                return (<div>
                    <FormGroup>
                    <h3 style={{ fontStyle: "italic", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>SPOUSAL SUPPORT</h3>

                    <h5 style={{ marginTop: "20px" }}>Each party must select an option for spousal support, not just the party earning less money.</h5>
                    </FormGroup>


                    <FormGroup>
                    <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>1. Let’s start with the Petitioner.</h6>
                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>Please select one of the options for Petitioner:</h6>
                        <Input type="select" onChange={(e) => setEqualizationFifth(JSON.parse(e.target.value))}>
                            <option disabled selected value>
                                {" "}
                                    -- select an option --{" "}
                            </option>
                            <option value="0">Petitioner will receive spousal support from the Respondent.</option>
                            <option value="1">Petitioner waives their right to receive spousal support from the Respondent.</option>
                            <option value="2">Petitioner reserves their right to receive spousal support from the Respondent.</option>
                        </Input>
                    </FormGroup>


                    <Collapse isOpen={equalizationFifth === 0 ? true : false} >
                        <FormGroup>
                            
                        </FormGroup>
                    </Collapse>

                    <Collapse isOpen={equalizationFifth === 1 ? true : false}>
                        <FormGroup>

                        </FormGroup>
                    </Collapse>

                    <Collapse isOpen={equalizationFifth === 2 ? true : false}>
                        <FormGroup>

                        </FormGroup>
                    </Collapse>


                    <FormGroup>
                    <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>2. Now, let’s do the Respondent.</h6>
                        <h6 style={{ marginTop: "20px", fontWeight: "bold" }}>Please select one of the options for Respondent:</h6>
                        <Input type="select" onChange={(e) => setEqualizationFifth(JSON.parse(e.target.value))}>
                            <option disabled selected value>
                                {" "}
                                    -- select an option --{" "}
                            </option>
                            <option value="0">Respondent will receive spousal support from the Petitioner.</option>
                            <option value="1">Respondent waives their right to receive spousal support from the Petitioner. </option>
                            <option value="2">Respondent reserves their right to receive spousal support from the Petitioner.</option>
                        </Input>
                    </FormGroup>


                    <Collapse isOpen={equalizationFifth === 0 ? true : false} >
                        <FormGroup>
                            
                        </FormGroup>
                    </Collapse>

                    <Collapse isOpen={equalizationFifth === 1 ? true : false}>
                        <FormGroup>

                        </FormGroup>
                    </Collapse>

                    <Collapse isOpen={equalizationFifth === 2 ? true : false}>
                        <FormGroup>

                        </FormGroup>
                    </Collapse>
                </div>);
            default:
                return 'Unknown step';
        }
    }


    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        <div className={classes.root}>
            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                        <StepContent>
                            <Typography>{getStepContent(index)}</Typography>
                            <div className={classes.actionsContainer}>
                                <div>
                                    <Button
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        className={classes.button}
                                    >
                                        Back
                  </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleNext}
                                        className={classes.button}
                                    >
                                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                    </Button>
                                </div>
                            </div>
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
            {activeStep === steps.length && (
                <Paper square elevation={0} className={classes.resetContainer}>
                    <Typography>All steps completed - you&apos;re finished</Typography>
                    <Button onClick={handleReset} className={classes.button}>
                        Reset
          </Button>
                </Paper>
            )}
        </div>
    );
}


export default MaritalSettlementAgreement;